/**
 * Status color constants for badges and lozenges
 * Matches the mobile app color scheme for consistency
 */

// Status color codes - hex values for direct use
// Enhanced colors for better visibility and significance - matches mobile app
export const STATUS_COLORS = {
  // Active/Working - Green
  active: {
    bg: "#10B98135", // Green with 35% opacity (more significant)
    text: "#047857", // Darker, more vibrant green
  },
  // Inactive/Not Working - Red
  inactive: {
    bg: "#EF444435", // Red with 35% opacity (more significant)
    text: "#B91C1C", // Darker, more vibrant red
  },
  // Waiting/Needs Attention - Orange
  pending: {
    bg: "#F59E0B35", // Orange with 35% opacity (more significant)
    text: "#B45309", // Darker, more vibrant orange
  },
  // Assembly - Blue
  assembly: {
    bg: "#3B82F635", // Blue with 35% opacity (more significant)
    text: "#1D4ED8", // Darker, more vibrant blue
  },
  // Packaging - Yellow/Amber
  packaging: {
    bg: "#EAB30835", // Yellow with 35% opacity (more significant)
    text: "#A16207", // Darker, more vibrant yellow
  },
  // Needs Maintenance - Orange/Red
  maintenance: {
    bg: "#F9731635", // Orange-red with 35% opacity (more significant)
    text: "#C2410C", // Darker, more vibrant orange-red
  },
  // Stock - Teal/Cyan
  stock: {
    bg: "#14B8A635", // Teal with 35% opacity (more significant)
    text: "#0D9488", // Darker, more vibrant teal
  },
  // Delivered/Completed Transaction - Purple
  delivered: {
    bg: "#8B5CF635", // Purple with 35% opacity (more significant)
    text: "#6D28D9", // Darker, more vibrant purple
  },
  // Sold - Purple (alias for delivered)
  sold: {
    bg: "#8B5CF635", // Purple with 35% opacity (more significant)
    text: "#6D28D9", // Darker, more vibrant purple
  },
  defective: {
    bg: "#EF444435", // Red with 35% opacity (more significant)
    text: "#B91C1C", // Darker, more vibrant red
  },
  // Completed - Green
  completed: {
    bg: "#10B98135", // Green with 35% opacity (more significant)
    text: "#047857", // Darker, more vibrant green
  },
  // Cancelled - Red
  cancelled: {
    bg: "#EF444435", // Red with 35% opacity (more significant)
    text: "#B91C1C", // Darker, more vibrant red
  },
  // Partial Delivery - Yellow/Orange
  partial_delivery: {
    bg: "#F59E0B35", // Orange with 35% opacity (more significant)
    text: "#B45309", // Darker, more vibrant orange
  },
  // Default/Unknown - Gray
  default: {
    bg: "#6B728030", // Gray with 30% opacity
    text: "#374151", // Darker gray
  },
};

// Status appearance mappings for Lozenge component
export const STATUS_APPEARANCE = {
  // Waiting/Needs Attention - Orange
  pending: "warning",
  // Active/Working - Green
  active: "success",
  // Inactive/Not Working - Red
  inactive: "danger",
  // Delivered/Completed Transaction - Blue/Purple
  delivered: "info",
  // Needs Maintenance - Orange
  maintenance: "warning",
  // Assembly - Blue
  assembly: "info",
  // Packaging - Warning (Yellow)
  packaging: "warning",
  // Active Production - Green
  production_active: "success",
  // Completed - Green
  completed: "success",
  // Cancelled - Red
  cancelled: "danger",
  // Partial Delivery - Orange
  partial_delivery: "warning",
  // Default/Unknown - Gray
  default: "default",
};

/**
 * Get status appearance for Lozenge component
 * @param {string} status - Status value
 * @returns {string} Appearance value for Lozenge component
 */
export const getStatusAppearance = (status) => {
  if (!status) return STATUS_COLORS.default;
  const normalizedStatus = status.toLowerCase();
  return STATUS_COLORS[normalizedStatus] || STATUS_COLORS.default;
};
